riot.tag2('highlight', '<div name="result"></div> <div style="display: none;" name="content"> <yield> </div>', '', '', function(opts) {
        this.on('update', () => {

            var content = this.content.innerText
            var searchQueries = this.opts.find.toLowerCase().split(' ')

            for (var searchQuery in searchQueries) {
                searchQuery = searchQueries[searchQuery]
                if (!!~content.toLowerCase().indexOf(searchQuery)) {
                    content = content.replace(

                        new RegExp(`(${searchQuery})(?!\<\/b\>)`, 'i'),
                        '<b>$1</b>'
                    )
                }
            }
            this.result.innerHTML = content
        })
});



// WEBPACK FOOTER //
// ./js/tags/highlight.html